import { apiGet } from '../../api'

export const get_program = () => {
  return apiGet({
    endpoint: `programs/get_program?default=true`
  })
}
